import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import {
  MyHrForgotPasswordEmailSentDialog,
  MyHrPublicLayoutData,
} from "my-hr/components";
import { MyHrForgotPasswordForm } from "my-hr/forms";
import { useOcClientState } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const MyHRUserForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [emailSent, setEmailSent] = useOcClientState<boolean>(
    "emailSent",
    false,
  );
  const isMobile = useOcIsMobile();

  const handleSendEmail = () => {
    setEmailSent(true);
  };

  useEffect(() => {
    return () => {
      setEmailSent(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (emailSent)
    return <MyHrForgotPasswordEmailSentDialog smallScreen={isMobile} />;

  return (
    <Box
      id="page-container"
      width="100%"
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      justifyContent="space-between"
      height="100%"
    >
      {!isMobile && <MyHrPublicLayoutData smallScreen={isMobile} />}
      <Box
        id="form-container"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        style={{ backgroundColor: "white" }}
        textAlign="center"
        width={isMobile ? "100%" : "400px"}
        height="100%"
      >
        <Box
          id="form-inner-container"
          width="100%"
          textAlign="center"
          padding="60px 0px"
          display="flex"
          flexDirection="row"
          justifyContent="center"
        >
          <Box padding="24px 48px" textAlign="center" width="304px">
            <Box marginBottom="24px" textAlign="center" color="#212121">
              <Typography variant="h6">
                {t("MY_HR_RECOVER_YOUR_PASSWORD")}
              </Typography>
            </Box>
            <Box color="#5E6366" textAlign="left">
              <Typography variant="caption" color="#5E6366">
                {t("MY_HR_TEXT_SEND_EMAIL_DESCRIPTION")}
              </Typography>
            </Box>
            <MyHrForgotPasswordForm onEmailSent={handleSendEmail} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MyHRUserForgotPasswordPage;
